<div class="grid">
  <div class="col-7">
    @if (store.asArray(); as tags) {
      <p-table
        #tagTable
        [globalFilterFields]="['title']"
        [loading]="loading"
        [value]="tags">
        <ng-template pTemplate="caption">
          <app-table-list-caption
            [searchWord]="searchWord"
            (clearTable)="clear(tagTable)"
            (search)="
              tagTable.filterGlobal($event, 'contains')
            "></app-table-list-caption>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th>Name</th>
            <th>Aktionen</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-tag>
          <tr>
            <td>
              <span class="flex align-items-center gap-3"
                ><i [class]="'w-1rem text-center fas fa-tag'"></i>
                {{ tag.title }}</span
              >
            </td>
            <td>
              <app-table-list-actions
                [item]="tag"
                (confirm)="confirm($event, tag, tag.title)">
              </app-table-list-actions>
            </td>
          </tr>
        </ng-template>
      </p-table>
    } @else {
      <div role="alert" class="p-message p-message-info">
        <div class="p-message-wrapper">
          <span class="p-message-summary">404</span>
          <span class="p-message-detail">Keine Farbsets gefunden</span>
        </div>
      </div>
    }
  </div>
  <div class="col-5">
    @if (store.globalTags(); as globalTags) {
      <app-header
        text="Schlagworte"
        icon="fas fa-tags"
        sub="Nutzen Sie bereits angelegte Schlagworte." />
      <div class="p-card surface-ground p-3">
        <app-tag-list [tags]="globalTags"></app-tag-list>
      </div>
    }
  </div>
</div>
<p-sidebar
  (onHide)="onOverlayClose()"
  position="right"
  [modal]="false"
  [styleClass]="'w-10'"
  [visible]="editFormOverlay">
  <ng-template pTemplate="header">
    <app-header
      [icon]="editFormOverlayIcon"
      [text]="editFormOverlayHeader"></app-header
  ></ng-template>

  <ng-container *ngIf="editFormOverlay">
    <router-outlet name="bearbeiten"></router-outlet>
  </ng-container>
</p-sidebar>
<app-mask [visible]="editFormOverlay" (click)="onOverlayClose()"></app-mask>
